<!--Barra de navegaciónn cuando no hay ningún usuario loggeado-->
<template>
  <v-container fluid class="pa-0 ma-0">
    <!-- MENÚ LATERAL PARA PANTALLAS MENORES A UNA TABLETA -->
    <v-navigation-drawer v-model="sidenav" dark fixed temporary :class="(currentEvent.hasOwnProperty('darkMode') && currentEvent.darkMode)?'dark-mode-2':'primary'">
      <v-list dense>
        <v-list-item v-for="item in menuItems" :key="item.title" link :to="item.link">
          <v-list-item-content>
            <v-list-item-title class="subtitle-1">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--<v-list-item key="Noticias" link href="https://www.redescomerciales.com.mx/" target="_blank">
          <v-list-item-content>
            <v-list-item-title class="subtitle-1">Noticias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->
        <v-list-item link to="/login" class="d-flex d-lg-none">
          <v-list-item-content>
            <v-list-item-title class="subtitle-1">Iniciar sesión</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- MENÚ LATERAL PARA PANTALLAS MENORES A UNA TABLETA -->

    <!-- MENÚ PARA PANTALLAS DE MAYOR TAMAÑO -->
    <v-app-bar app :class="(currentEvent.hasOwnProperty('darkMode') && currentEvent.darkMode)?'':'primary'" :dark="(currentEvent.hasOwnProperty('darkMode') && currentEvent.darkMode)?true:false">
      <v-toolbar-title class="headline mr-5">
        <v-img src="@/assets/logo-WC-solo.png" width="45px" height="auto" @click="home()"></v-img>
      </v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn class="text-capitalize" v-for="item in menuItems" :key="item.title" text exact :to="item.link">
          {{ item.title}}
        </v-btn>
        <!--<v-btn class="text-capitalize" key="Noticias" text exact href="https://www.redescomerciales.com.mx/" target="_blank">
          Noticias
        </v-btn>-->
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn class="text-capitalize" text exact to="/login">
          Iniciar Sesión
        </v-btn>
      </v-toolbar-items>
      <v-app-bar-nav-icon dark @click.native.stop="sidenav = !sidenav" class="d-md-none mr-1"></v-app-bar-nav-icon>
    </v-app-bar>
    <!-- MENÚ PARA PANTALLAS DE MAYOR TAMAÑO -->

  </v-container>
</template>
<script>
import { mapState } from "vuex";
export default {
  data(){
    return {
      sidenav:false,
      menuItems:[ 
        { title:'Inicio', link:"/" },
        { title:'Eventos', link:"/eventos" },
        //{ title:'Afiliaciones', link:"/afiliaciones" },
        { title:'¿Cómo funciona?', link:"/como-funciona" },
        { title:'Nosotros', link:"/nosotros" }
      ]
    }
  },
  computed:{
    ...mapState("event", ["currentEvent"]),
  },
  methods: {
    home(){
      this.$router.push("/");
    }
  }
}
</script>
<style scoped>
  .v-application a{
    color:white
  }
</style>